import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-border spinner-border-sm mb-1",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#a6a6a6"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1))
    : _createCommentVNode("", true)
}